// extracted by mini-css-extract-plugin
module.exports = {"squareWrap":"WinBanner_squareWrap_AePX7","faTimes":"WinBanner_faTimes_3lv9k","faCircle":"WinBanner_faCircle_1jWaY"};